export default __webpack_public_path__ + "static/media/pointInvert.b96f833e.svg";